import axios from 'axios';

const API_PREFIX = 'api/fe/marketplace';

const FEATURE_LIST = {
  'featureDishwasher': 'dishwasher',
  'featureEnsuiteRoom': 'ensuiteRoom',
  'featureSmokingAllowed': 'smokingAllowed',
  'featureWater': 'water',
  'featureWifi': 'wifi',
  'featureCentralHeat': 'central_heat',
  'featureCouncilTax': 'council_tax',
  'featureElectricity': 'electricity',
  'featureGas': 'gas',
  'featureHeating': 'heating',
  'featureOven': 'oven',
  'featureBalcony': 'balcony',
  'featureElevator': 'elevator',
  'featurePool': 'pool',
  'featureDryer': 'dryer',
  'featureParking': 'parking',
  'featureExterior': 'exterior',
  'featureWithDesk': 'withDesk',
  'featureWashingMachine': 'washing_machine',
  'featureAirConditioning': 'air_conditioning',
  'featureCouples': 'couples',
  'featureStudents': 'students',
  'featurePets': 'pets',
  'featuresOnlyFemale': 'only_female',
  'featureOnlyMale': 'only_male'
};

const specialFeaturesFromFilters = (filters) => {
  let specialFeatures = [];
  if (filters.noDeposit === 1) specialFeatures.push('noDeposit');
  if (filters.instantBooking === '1') specialFeatures.push('instantBooking');
  if (filters.superLister === '1') specialFeatures.push('superLister');
  if (filters.verified === '1') specialFeatures.push('verified');

  return specialFeatures.length > 0 ? specialFeatures.join(',') : null;
};

const poiFromFilters = (filters) => {
  if (null !== filters.poiLat && null !== filters.poiLng) {
    return filters.poiLat + ',' + filters.poiLng;
  }

  return null;
};

const minimumPriceFromBudget = budget => {
  if ('' !== budget) {
    return parseInt(budget.split('-')[0], 10);
  }

  return null;
};

const maximumPriceFromBudget = budget => {
  if ('' !== budget) {
    return parseInt(budget.split('-')[1], 10);
  }

  return null;
};

const buildFeatures = filterFeatures => {
  let features = {};
  Object.keys(FEATURE_LIST).forEach((key, index) => {
    features[key] = filterFeatures.includes(FEATURE_LIST[key]);
  });

  return features;
};

export function trackSearchQueryRequest(city, filters, numberOfResults) {
  const path = `/${API_PREFIX}/search-query`;

  return axios.post(
    path,
    {
      city,
      moveIn: filters.moveIn ? filters.moveIn : null,
      moveOut: filters.moveOut ? filters.moveOut : null,
      flexibleMoveIn: !!filters.flexibleMoveIn,
      flexibleMoveOut: !!filters.flexibleMoveOut,
      minimumPrice: minimumPriceFromBudget(filters.budget),
      maximumPrice: maximumPriceFromBudget(filters.budget),
      propertyTypeApartments: filters.type.includes('apartments'),
      propertyTypeStudios: filters.type.includes('studios'),
      propertyTypeRooms: filters.type.includes('rooms'),
      propertyTypeResidences: filters.type.includes('residences'),
      numberBedrooms: filters.topology.length > 0 ? filters.topology.join(',') : null,
      specialFeatures: specialFeaturesFromFilters(filters),
      neighborhoods: filters.areaId.length > 0 ? filters.areaId.join(',') : null,
      bedTypes: filters.bed ? filters.bed : null,
      numberBathrooms: filters.bathrooms.length > 0 ? filters.bathrooms.join(',') : null,
      poi: poiFromFilters(filters),
      sortBy: filters.sortBy,
      pageNumber: filters.page,
      numberOfResults,
      ...buildFeatures(filters.features)
    }
  );
}

export default {
  trackSearchQueryRequest
};
